let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5EnrL")).then(() => parcelRequire('gn51B'));